
function Banner() {
    this.build();
    barbaCallbacks.push(this);
}

Banner.prototype.build = function(){

    $('.banner-patch-mh').matchHeight({
        byRow : false
    });
    $('.banner-patch-price-mh').matchHeight({
        byRow : false
    });

    $('.banner-mentions-btn').on('click', function(){
       $('.banner-mentions').slideToggle();
    });

    this.index = 0;
    this.city = [];
    this.average = [];
    this.primmea = [];
    let that = this;

    if( $('.banner-animation-step').length > 0 ) {

        $('.banner-animation-step').each(function () {
            that.city.push($('.banner-animation-step-city', this).text());
            that.average.push($('.banner-animation-step-average', this).text());
            that.primmea.push($('.banner-animation-step-primmea', this).text());
        });
        that.change();

    }

};

Banner.prototype.change = function(){

    let that = this;
    let primmeaRender = $('.banner-patch-primmea-price--render');

    primmeaRender.prop('Counter', that.primmea[this.index-1]).animate({
        Counter: that.primmea[this.index]
    }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {
            primmeaRender.text(Math.ceil(now).toLocaleString());
        }
    });

    let priceRender = $('.banner-patch-average-price--render');

    priceRender.prop('Counter', that.average[this.index-1]).animate({
        Counter: that.average[this.index]
    }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {
            priceRender.text(Math.ceil(now).toLocaleString());
        }
    });

    let cityRender = $('.banner-patch-city--render');
    cityRender.html(that.city[this.index]);
    // cityRender.shuffleLetters({
    //     "text": that.city[this.index]
    // });

    this.index += 1;
    if( this.index >= $('.banner-animation-step').length ){
        this.index = 0;
    }

    if( !this.interval ) {
        this.interval = setInterval(
            function () {
                that.change();
            }, 4000
        );
    }

};
